import { Box } from '@chakra-ui/react';
import { ComponentHeader } from './containers/ComponentHeader';
import { ComponentList } from './containers/ComponentList';
import { ComponentRegistrationModal } from './containers/ComponentRegistrationModal';
import { ComponentEditModal } from './containers/ComponentEditModal';
import { ComponentDeleteModal } from './containers/ComponentDeleteModal';

export const ReleaseComponentPageView = () => (
  <Box m="40px">
    {/* ヘッダ */}
    <ComponentHeader />
    {/* コンポーネント一覧 */}
    <ComponentList />
    {/* コンポーネント登録モーダル */}
    <ComponentRegistrationModal />
    {/* コンポーネント登録モーダル */}
    <ComponentEditModal />
    {/* コンポーネント削除モーダル */}
    <ComponentDeleteModal />
  </Box>
);
